module.exports = __webpack_public_path__ + "img/Number=28.97038949.png";